import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { JournalRow } from "./JournalRow";

const COLS = ["number", "ref", "date", "branch", "type", "desc", "debit", "credit", "status", "act"];

// ظل 3D عميق على حاوية الجدول (HELCOO 3D Neu — Card).
const CARD_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};

// جدول القيود بأسلوب HELCOO 3D Neu: حاوية غاطسة + رأس ملوّن + صفوف قابلة للتوسيع.
export const JournalTable = ({ entries, branchNameById, canManage, onReverse }) => {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <NeuCard className="overflow-x-auto p-0" style={CARD_3D} data-testid="journal-table">
      <table className="w-full text-sm">
        <thead className="bg-gradient-to-l from-primary/15 via-primary/8 to-transparent">
          <tr className="text-[11px] font-black uppercase text-muted-foreground">
            {COLS.map((c) => (
              <th key={c} className="px-3 py-3 text-start whitespace-nowrap">
                {t(`acct.journal.col.${c}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {entries.length === 0 ? (
            <tr><td colSpan={COLS.length} className="px-3 py-8 text-center text-sm text-muted-foreground">
              {t("acct.noEntries")}
            </td></tr>
          ) : entries.map((entry) => (
            <JournalRow key={entry.id} entry={entry}
                        branchName={branchNameById[entry.branch_id]}
                        expanded={openId === entry.id}
                        onToggle={toggle}
                        canReverse={canManage}
                        onReverse={onReverse} />
          ))}
        </tbody>
      </table>
    </NeuCard>
  );
};
